import { Navigate } from 'react-router-dom';

import useScreenSize from '@/hooks/useScreenSize';
import useTranslations from '@/i18n/useTranslations';
import SettingsMenu from '@/layouts/navigation/user-settings/components/SettingsMenu';
import SettingsHeading from '@/shared-components/text/components/SettingsHeading';

export default function SettingsIndex() {
  const screenSize = useScreenSize();
  const t = useTranslations('common.user_settings.settings_index');

  if(screenSize.width > 700) {
    return <Navigate to="/profile/settings/login" replace/>;
  }

  return (
    <>
      <SettingsHeading text={t('heading')} to="/profile"/>
      <SettingsMenu/>
    </>
  );
}
